jQuery(document).on('mobileinit',function(){



  $.mobile.loader.prototype.options.html = "<div class='sk-three-bounce'><div class='sk-child sk-bounce1'></div><div class='sk-child sk-bounce2'></div><div class='sk-child sk-bounce3'></div></div>";
$(function(){ 
   $( "#header" ).toolbar();
   $( "[data-role = 'navbar']" ).navbar();
  $("#mobilemenu").panel();
   //disable page transition
    $.mobile.defaultPageTransition = 'fade';
});
  
});


$(document).one("pagecontainershow", function (event,ui) {
   window.loaded = true; 
   function logLoaded2() {
   jQuery('html').addClass('loaded');
    }

    (function listen2() {
        if (window.loaded) {
            logLoaded2();

        } else {
            window.setTimeout(listen2, 50);
        }
    })();  
});
